import { render, staticRenderFns } from "./DialogAddLink.vue?vue&type=template&id=70a6c0b3&scoped=true&"
import script from "./DialogAddLink.vue?vue&type=script&lang=js&"
export * from "./DialogAddLink.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddLink.vue?vue&type=style&index=0&id=70a6c0b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6c0b3",
  null
  
)

export default component.exports